import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import moment from "moment";
import {
    InputGroup,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    SummaryTitle,
} from "../Styles/InputStyles";

import Config from "../../Config";
import { useState } from "react";
import { FiEdit2 } from "react-icons/fi";
import { addDays, getDueIcon, getDueLabel } from "../../helpers";

const InitiateTenantEvictionStepTwo = ({
    data,
    editDueLoading,
    editDueMutate,
    setInitiateEviction,
    setStep,
    initiateEvictionMutate,
    initiateEvictionLoading,
    stepOneData,
    routeData,
    handlePrevStep,
    step1Values,
    setIsAddDuesModal,
}) => {
    const moveInDate = routeData?.moveInDate ? moment(routeData.moveInDate) : null;
    const moveOutDate = step1Values?.moveOutDate ? moment(step1Values.moveOutDate) : null;
    const agreementPeriod = routeData?.agreementPeriod || 0;
    const defaultMoveOutDate = moveOutDate ? moveOutDate : moveInDate?.clone().add(agreementPeriod, "months");
    const [isEditing, setIsEditing] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editedValue, setEditedValue] = useState("");
    const [dueEditId, setDueEditId] = useState(null);
    const [isTemp, setIsTemp] = useState(false);
    const [adjustFromSecurity, setAdjustFromSecurity] = useState(false);
    const [forfeitRefund, setForFeitRefund] = useState(false);
    const dues = data?.data?.dues.map((item) => ({
        label: getDueLabel(item.type),
        amount: item.balance,
        rentStartDate: item.rentStartDate,
        rentEndDate: item.rentEndDate,
        icon: getDueIcon(item.type),
        id: item.id,
        isTemp: item.isTemp,
    }));
    const handleEditClick = (dueId, amount, index, due) => {
        if (editingIndex === index) {
            setEditingIndex(null);
        } else {
            setEditingIndex(index);
            setEditedValue(amount);
            setDueEditId(dueId);
            setIsTemp(due.isTemp);
        }
    };

    const handleEditSubmit = () => {
        editDueMutate({
            dueId: dueEditId,
            newAmount: parseInt(editedValue),
            isTemp: isTemp,
            tenantId: stepOneData?.tenantId,
            isEvicted: false,
        });
        setEditingIndex(null);
    };
    const handleClose = () => {
        setInitiateEviction(false);
        setStep(1);
    };
    const securityAmount = data?.data?.securityAmount || 0;
    const actualDues = data?.data?.totalDues;
    const totalDues = adjustFromSecurity
        ? data?.data?.totalDues - securityAmount
        : data?.data?.totalDues;

    const initialValues = {
        tenantId: stepOneData?.tenantId,
        date: stepOneData?.date,
        moveOutDate: defaultMoveOutDate.format("YYYY-MM-DD"),
        isSecurityAdjustment: "",
        forfeitRefund: "",
    }
    const handleSubmit = (values) => {
        initiateEvictionMutate({
            tenantId: stepOneData?.tenantId,
            calculationDate: stepOneData?.date,
            isSecurityAdjustment: adjustFromSecurity,
            moveOutDate: defaultMoveOutDate.format("YYYY-MM-DD"),
            requestId: routeData?.requestId || '',
            forfeitRefund: forfeitRefund ? 1 : 0,
        })
    };

    return (
        <Formik onSubmit={handleSubmit} initialValues={initialValues}>
            {({ values, setFieldValue }) => (
                <Form>

                    <ScrollableContent className="px-4">
                        <Wrapper>
                            <InputGroup>
                                <div className="flex justify-between">
                                    <SummaryTitle>Dues</SummaryTitle>
                                    {/* <button type="button" className="text-primary-color text-sm underline" onClick={() => setIsAddDuesModal(true)}>Add Dues</button> */}
                                </div>
                                {dues?.map((due, index) => (
                                    <DuesItem key={due.id}>
                                        <DuesLabel>
                                            {due.icon}
                                            <span>{(due.label === 'Rent' || due.label === 'Fine') ?
                                                due.label + ' : ' + moment(due?.rentStartDate || new Date()).format(
                                                    'DD MMM YY',
                                                ) +
                                                ' - ' +
                                                moment(
                                                    due?.rentEndDate || addDays(new Date(), 30),
                                                ).format('DD MMM YY')
                                                :
                                                due.label
                                            }</span>
                                            <EditIcon
                                                onClick={() =>
                                                    handleEditClick(due.id, due.amount, index, due)
                                                }
                                            >
                                                <FiEdit2 />
                                            </EditIcon>
                                        </DuesLabel>
                                        {editingIndex === index ? (
                                            <div className="flex items-center space-x-2">
                                                <input
                                                    type="number"
                                                    value={editedValue}
                                                    onChange={(e) => setEditedValue(e.target.value)}
                                                    className="ml-2 w-24 p-1 border rounded"
                                                />

                                                <button
                                                    type="button"
                                                    onClick={handleEditSubmit}
                                                    className="bg-white text-primary-color border border-primary-color px-2 py-1.5 rounded text-xs"
                                                    disabled={!editedValue || editDueLoading}
                                                >
                                                    {editDueLoading ? "Submitting..." : "Submit"}
                                                </button>
                                            </div>
                                        ) : (
                                            <Amount>₹{due.amount.toLocaleString()}</Amount>
                                        )}
                                    </DuesItem>
                                ))}
                                {securityAmount > 0 && actualDues > 0 && (
                                    <InputGroup>
                                        <div className="flex items-center justify-between my-2">
                                            <label className="inline-flex items-center cursor-pointer">
                                                <Field
                                                    type="checkbox"
                                                    id="adjustFromSecurity"
                                                    checked={adjustFromSecurity}
                                                    onChange={(e) =>
                                                        setAdjustFromSecurity(e.target.checked)
                                                    }
                                                />
                                            </label>
                                            <Label htmlFor="adjustFromSecurity">
                                                Adjust from security (₹{securityAmount.toLocaleString()}
                                                )
                                            </Label>
                                        </div>
                                    </InputGroup>
                                )}
                                <InputGroup>
                                    <div className="flex items-center justify-between my-2">
                                        <label className="inline-flex items-center cursor-pointer">
                                            <Field
                                                type="checkbox"
                                                id="forfeitRefund"
                                                checked={forfeitRefund}
                                                onChange={(e) =>
                                                    setForFeitRefund(e.target.checked)
                                                }
                                            />
                                        </label>
                                        <Label htmlFor="foFitRefund">
                                            Retain Security Deposit
                                        </Label>
                                    </div>
                                </InputGroup>
                                <TotalDues>
                                    <span>Total dues</span>
                                    <span>₹{totalDues}</span>
                                </TotalDues>
                            </InputGroup>
                        </Wrapper>
                    </ScrollableContent>

                    <ActionSection>
                        <SideCancelBtn type="button" onClick={handlePrevStep}>
                            Back
                        </SideCancelBtn>
                        <SubmitBtn type="submit" disabled={initiateEvictionLoading}>{initiateEvictionLoading ? "Loading..." : "Initiate Eviction"}</SubmitBtn>
                    </ActionSection>
                </Form>
            )}
        </Formik>
    );
};

// Styled Components
const OptionCard = tw.div`
  flex flex-col items-center justify-center p-2 rounded-lg shadow border border-gray-200 text-center
  cursor-pointer transition-all duration-200 
  ${(props) =>
        props.isSelected
            ? "bg-blue-50 border-blue-500"
            : "bg-white hover:bg-gray-50"}
`;
const DuesItem = tw.div`flex justify-between items-center py-1 border-b last:border-b-0`;
const DuesLabel = tw.div`flex items-center space-x-2 text-sm text-gray-600`;
const EditIcon = tw.span`text-gray-400 cursor-pointer text-sm hover:text-gray-600`;
const Amount = tw.div`text-gray-800 font-medium text-base`;
const TotalDues = tw.div`flex justify-between items-center text-base font-semibold border-b pb-1 text-gray-900`;

export default InitiateTenantEvictionStepTwo;
